import React, { useEffect, useState, useRef, useMemo } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ArrowRightOutlined } from '@ant-design/icons';
import { generateClassName } from "jzfz-web-utils";
import { queryMenuContentList } from '../../store/action';
import { ObjTest } from "../../util/common";
import { ViewportImg } from '../../component/viewportImg';
import { constantConfig, commonUtil } from 'web-common';



import './style/periodical.less';




const bannerPC = require('../../assets/images/read/periodicalPCBanner.jpg');
const bannerMOBILE = require('../../assets/images/read/periodicalMOBILEBanner.jpg');


const { ModuleTypeEnum, WEBSITE_PATHS } = constantConfig;
const { waterColumnsArray } = commonUtil;


// 列表子项边距
const MARGIN = 32;



/**
 * 基准之道
 */
const Periodical = () => {

	const history = useHistory();

	const { isMobile } = useSelector((state: any) => state.reducer);

	const [contentList, setContentList] = useState<any[]>([]);

	const containerRef = useRef<any>(null);
	// 设置渲染的列数
	const columnCount = useMemo(() => isMobile ? 1 : 4, [isMobile]);


	useEffect(() => {
		initContentList();
	}, []);


	/**
	 * 初始化内容列表
	 */
	const initContentList = async () => {
		const result = await queryMenuContentList(ModuleTypeEnum.PERIODICAL);
		const arrs = result.data || [];
		if (Array.isArray(arrs)) {
			setContentList(arrs);
		}
	}; 


	/**
	 * 计算列的宽度
	 * @param item
	 */
	const getColumnWidth = () => {
		if (isMobile) {
			return '100%';
		}
		if (containerRef.current && columnCount) {
			const width = containerRef.current.offsetWidth;
			const marginCount = MARGIN * (columnCount - 1);
			return (width - marginCount) / columnCount;
		}
		return 0;
	};


	/**
	 * 跳转到视觉美学页面
	 */
	const openAestheticePath = () => {
		history.replace(WEBSITE_PATHS.aesthetice);
	};

	
	/**
	 * 打开基准之道PDF文件
	 * @param fileUrl 
	 */
	const openPeriodicalFileUrl = (fileUrl: string) => {
		window.open(fileUrl, '_blank');
	};


    return (
		<div className="company-periodical-wrapper">
			{/* banner */}
			<div className="banner ofh">
				<img src={isMobile ? bannerMOBILE : bannerPC} className="w" loading="lazy" />
				<div className="structure">大咨询 ｜ 大设计 ｜ 大管理</div>
			</div>

			{/* 线 */}
			<div className={generateClassName(["tr ptb24 link-title", isMobile ? "mlr16" : "mlr75"])}>
				<span className="f12 crp" onClick={openAestheticePath}>视觉美学<ArrowRightOutlined /></span>
			</div>

			{/* 内容-基准之道 */}
			<div className={isMobile ? "mlr16" : "mlr75"}>
				<div className={generateClassName(["mt18 content-title", isMobile ? "f18" : "f36"])}>
					基准之道
				</div>
				<div className="mb60 w pt12 flex read-list" ref={containerRef}>
					{
						(waterColumnsArray(contentList, columnCount) || []).map((columns: any[], columnsIndex: number) => {
							return (
								<div key={columnsIndex} style={{ width: getColumnWidth(), marginLeft: columnsIndex > 0? MARGIN : 0 }}>
									{
										ObjTest.isNotEmptyArray(columns) ? (
											(columns || []).map((v, vi) => {
												if (!v) { return null;}
												return (
													<div key={vi} className="read-item mt24 crp" onClick={() => openPeriodicalFileUrl(v.fileUrl)}>
														<ViewportImg src={v.coverImage || null} loading="lazy" />
													</div>
												);
											})
										) : (
											null
										)
									}
								</div>
							);
						})
					}
				</div>
			</div>
		</div>
	)
};

export { Periodical };